import type { DocumentMeta } from "@prismicio/editor-fields"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  IconButton,
} from "@prismicio/editor-ui"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { invalidateReleasesListData } from "../../app/services/release"
import { GenerateLandingPagesDialog } from "./generateLandingPages/GenerateLandingPagesDialog"

interface DocumentListPageOptionsProps {
  document: DocumentMeta
  options: {
    generateProductLandingPages: boolean
    personalizeLandingPageForABM: boolean
  }
}

type Dialog = "personalizeLandingPageForABM" | "generateProductLandingPages"

export function DocumentListPageOptions({
  document,
  options,
}: DocumentListPageOptionsProps) {
  const navigate = useNavigate()

  function onSelect({ dialogName }: { dialogName: Dialog }) {
    setDialog(dialogName)
  }

  const [dialog, setDialog] = useState<Dialog>()

  return (
    <>
      <DropdownMenu modal>
        <DropdownMenuTrigger>
          <IconButton icon="moreVert" variant="solid" />
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Page options</DropdownMenuLabel>
          {options.generateProductLandingPages && (
            <DropdownMenuItem
              startIcon="autoFixHigh"
              onSelect={() =>
                onSelect({
                  dialogName: "generateProductLandingPages",
                })
              }
            >
              Generate Product Landing Pages
            </DropdownMenuItem>
          )}
          {options.personalizeLandingPageForABM && (
            <DropdownMenuItem
              startIcon="autoFixHigh"
              onSelect={() =>
                onSelect({
                  dialogName: "personalizeLandingPageForABM",
                })
              }
            >
              Personalize Landing Page for ABM
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {dialog && (
        <GenerateLandingPagesDialog
          variant={dialog}
          document={document}
          onCloseRequest={async (taskState) => {
            setDialog(undefined)
            const releaseId = taskState.taskResults?.release?.id
            if (taskState.status === "SUCCEEDED" && releaseId) {
              await invalidateReleasesListData()
              navigate(`/upcoming/${releaseId}`)
            }
          }}
        />
      )}
    </>
  )
}
